import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../api";
import InputData from "../components/InputData";
import { CustomModal } from "../components/CustomModal";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
  Icon,
} from "@mui/material";

export default function FormLaporanKerusakan() {
  const navigate = useNavigate();
  const [nama_alat, setNamaAlat] = useState("");
  const [serial_number, setSerialNumber] = useState("");
  const [keterangan_kerusakan, setKeteranganKerusakan] = useState("");
  const [nama_pengguna, setNamaPengguna] = useState("");
  const [lokasi, setLokasi] = useState("");
  const [loading, setLoading] = useState(false);

  const [namaList, setNamaList] = useState([]);
  const [namaSearchText, setNamaSearchText] = useState("");
  const [namaSuggestions, setNamaSuggestions] = useState([]);
  const [showNamaSuggestions, setShowNamaSuggestions] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "info",
    buttons: [],
  });

  const showModal = (title, message, type = "info", buttons = []) => {
    setModalConfig({ title, message, type, buttons });
    setModalVisible(true);
  };

  useEffect(() => {
    const fetchNama = async () => {
      try {
        const res = await fetch(`${API_URL}/user/nama-users`);
        const json = await res.json();
        if (json.success) {
          setNamaList(json.data);
        } else {
          console.error("Gagal mengambil nama:", json.message);
        }
      } catch (err) {
        console.error("Gagal fetch nama pengguna:", err);
      }
    };
    fetchNama();
  }, []);

  const handleSearchNama = (text) => {
    setNamaSearchText(text);
    setNamaPengguna(text);
    if (text.trim() === "") {
      setShowNamaSuggestions(false);
      return;
    }
    const filtered = namaList.filter((name) =>
      name.toLowerCase().includes(text.toLowerCase())
    );
    setNamaSuggestions(filtered);
    setShowNamaSuggestions(true);
  };

  const validateForm = () => {
    if (
      !lokasi ||
      !nama_pengguna ||
      !serial_number ||
      !nama_alat ||
      !keterangan_kerusakan
    ) {
      showModal(
        "Data Belum Lengkap",
        "Harap lengkapi semua data yang wajib diisi",
        "warning"
      );
      return false;
    }
    return true;
  };

  const showConfirmationModal = () => {
    if (!validateForm()) return;
    showModal(
      "Konfirmasi",
      "Apakah data yang dimasukkan sudah benar?",
      "info",
      [
        { text: "Batal", onPress: () => setModalVisible(false) },
        { text: "Ya, Kirim", onPress: handleSubmit },
      ]
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/alat/kondisi`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          lokasi,
          nama_pengguna,
          nama_alat,
          serial_number,
          keterangan_kerusakan,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        showModal(
          "Berhasil!",
          "Laporan Kerusakan berhasil dikirim!",
          "success",
          [{ text: "OK", onPress: () => window.history.back() }]
        );
      } else {
        alert(data.error || "Gagal menyimpan Laporan Kerusakan");
      }
    } catch (error) {
      console.error("Error:", error);
      showModal("Gagal", "Terjadi kesalahan jaringan", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <header className="app-header">
        <div className="header-content">
          <button className="back-button" onClick={() => navigate(-1)}>
            <Icon>arrow_back</Icon>
          </button>
          <h1 className="header-title"> Laporan Kerusakan</h1>
          <div className="header-spacer"></div>
        </div>
      </header>
      <Box sx={{ mx: "auto", mt: 4, p: 2 }}>
        <Paper sx={{ p: 3, mb: 3, mx: "auto" }}>
          <Typography variant="h5" gutterBottom>
            Laporan Kerusakan
          </Typography>

          {/* Lokasi */}
          <InputData
            label="Tim"
            isDropdown
            value={lokasi}
            onChange={(e) => setLokasi(e.target.value)}
            itemsDropdown={[
              { label: "Pit Utara", value: "Pit Utara, KM 22" },
              {
                label: "Pit Selatan",
                value: "Pit Selatan, Office 33",
              },
              { label: "Tim Drone", value: "Drone, Head Office" },
            ]}
          />

          {/* Nama Pengguna */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" gutterBottom>
              Nama Pengguna
            </Typography>
            <TextField
              fullWidth
              placeholder="Nama Pengguna"
              value={namaSearchText}
              onChange={(e) => handleSearchNama(e.target.value)}
            />
            {showNamaSuggestions && (
              <Paper sx={{ mt: 1, maxHeight: 200, overflowY: "auto" }}>
                {namaSuggestions.length > 0 ? (
                  namaSuggestions.map((name, index) => (
                    <Box
                      key={index}
                      sx={{
                        p: 1,
                        cursor: "pointer",
                        "&:hover": { bgcolor: "#eee" },
                      }}
                      onClick={() => {
                        setNamaSearchText(name);
                        setNamaPengguna(name);
                        setShowNamaSuggestions(false);
                      }}
                    >
                      {name}
                    </Box>
                  ))
                ) : (
                  <Box sx={{ p: 1, color: "gray" }}>Nama tidak ditemukan</Box>
                )}
              </Paper>
            )}
          </Box>

          {/* Nama Alat */}
          <InputData
            label="Nama Alat"
            placeholder="Nama Alat"
            value={nama_alat}
            onChange={(e) => setNamaAlat(e.target.value)}
          />

          {/* Serial Number */}
          <InputData
            label="Serial Number"
            placeholder="Masukan Serial Number Alat"
            value={serial_number}
            onChange={(e) => setSerialNumber(e.target.value)}
          />

          {/* Keterangan */}
          <InputData
            label="Keterangan Rusak"
            placeholder="Keterangan Rusak"
            multiline
            rows={3}
            value={keterangan_kerusakan}
            onChange={(e) => setKeteranganKerusakan(e.target.value)}
          />

          {/* Tombol Kirim */}
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={showConfirmationModal}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "KIRIM LAPORAN"}
            </Button>
          </Box>

          {/* Modal */}
          <CustomModal
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            title={modalConfig.title}
            message={modalConfig.message}
            type={modalConfig.type}
            buttons={modalConfig.buttons}
          />
        </Paper>
      </Box>
    </div>
  );
}
